import getOption, {
  OPTION_ALL_VALUE,
  // OPTION_NO_PARTNER_GROUP_VALUE,
} from 'lib/getOption'
import { TABLE_DIRECTION_ASC, TABLE_DIRECTION_DESC } from 'lib/tableLib'
import { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

const useRulesFilters = () => {
  const { t } = useTranslation()

  const allOption = useMemo(
    () => getOption(t('common.form.all'), OPTION_ALL_VALUE),
    [t]
  )

  // const noPartnerGroupOption = useMemo(
  //   () =>
  //     getOption(t('common.form.noPartnerGroup'), OPTION_NO_PARTNER_GROUP_VALUE),
  //   [t]
  // )

  const defaultFilters = useMemo(
    () => ({
      partners: [OPTION_ALL_VALUE],
      partnersId: [OPTION_ALL_VALUE],
      partnersGroup: [OPTION_ALL_VALUE],
      order: { column: 'partnerGroup', direction: TABLE_DIRECTION_ASC },
    }),
    []
  )

  const [filters, setFilters] = useState({
    ...defaultFilters,
    initialized: false,
  })

  const [filtersData, setFiltersData] = useState({
    partners: [allOption],
    partnersId: [allOption],
    partnersGroup: [allOption],
  })

  const resetFilters = useCallback(() => {
    setFilters((s) => ({
      ...s,
      ...defaultFilters,
    }))
  }, [defaultFilters])

  const initFilters = useCallback(
    async (partners) => {
      setFiltersData((s) => ({
        ...s,
        partners: [
          allOption,
          ...partners.map((partner) =>
            getOption(partner.name, partner.partnerId)
          ),
        ],
        partnersId: [
          allOption,
          ...partners.map((partner) => getOption(partner.partnerId)),
        ],
        partnersGroup: [
          allOption,
          ...partners
            .map((partner) => getOption(partner.partnerGroup))
            .reduce(
              (acc, curr) =>
                acc.findIndex((f) => f.label === curr.label) > -1
                  ? acc
                  : [...acc, curr],
              []
            )
            .filter((f) => f.label),
          // noPartnerGroupOption,
        ],
      }))

      setFilters({
        ...defaultFilters,
        initialized: true,
      })
    },
    [allOption, defaultFilters]
  )

  const setPartners = useCallback(
    (value) => {
      setFilters((s) => ({ ...s, partners: value }))
    },
    [setFilters]
  )

  const setPartnersId = useCallback(
    (value) => {
      setFilters((s) => ({ ...s, partnersId: value }))
    },
    [setFilters]
  )

  const setPartnerGroup = useCallback(
    (value) => {
      setFilters((s) => ({ ...s, partnersGroup: value }))
    },
    [setFilters]
  )

  const setSort = useCallback(
    (value) => {
      setFilters((s) => ({
        ...s,
        order: {
          column: value,
          direction:
            s.order.column !== value ||
            s.order.direction !== TABLE_DIRECTION_ASC
              ? TABLE_DIRECTION_ASC
              : TABLE_DIRECTION_DESC,
        },
      }))
    },
    [setFilters]
  )

  const filter = useCallback((items, filters) => {
    return items.filter((item) => {
      if (
        [item.partnerId, OPTION_ALL_VALUE].every(
          (partner) => !filters.partners.includes(partner)
        )
      )
        return false

      if (
        [item.partnerId, OPTION_ALL_VALUE].every(
          (partner) => !filters.partnersId.includes(partner)
        )
      )
        return false

      if (
        [item.partnerGroup ?? '', OPTION_ALL_VALUE].every(
          (partner) => !filters.partnersGroup.includes(partner)
        )
      )
        return false

      return true
    })
  }, [])

  return {
    filters,
    filtersData,
    initFilters,
    setPartners,
    setPartnersId,
    setPartnerGroup,
    setSort,
    filter,
    resetFilters,
    initialized: filters.initialized,
  }
}
export default useRulesFilters
